export enum UserRole {
  Master = "M",
  Owner = "O",
  Arbeit = "S",
  Client = "C",
  Partner = "P",
  Manager = "G",
  Artist = "A"
}
